@if (visibility) {
  <div class="online-courses-wayfinder-banner" role="region" aria-label="Online courses wayfinder">
    <button
      class="online-courses-wayfinder-banner__button"
      type="button"
      (click)="handleBannerClick()"
      [lxGAClickEvent]="dataLayerEventName"
      [attr.aria-label]="'Explore our online courses'"
    >
      <div class="online-courses-wayfinder-banner__content">
        <div class="online-courses-wayfinder-banner__icon" aria-hidden="true"></div>
        <div class="online-courses-wayfinder-banner__text">
          <span class="online-courses-wayfinder-banner__primary-text" i18n>Prefer to study online?</span
          ><span class="online-courses-wayfinder-banner__secondary-text" i18n>Explore our online courses →</span>
        </div>
      </div>
    </button>
  </div>
}
